import { Button, Icon, Tag, Text } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';

const NumberedCircle = ({ value }: { value: number }) => (
  <div className="flex h-6 w-6 items-center justify-center rounded-circle border border-border-default bg-surface-default">
    <Text size="labelStrong" color="contentDefault">
      {value}
    </Text>
  </div>
);

export const AdditionalConditionEndPage = () => {
  const { t } = useTranslation('treatments', {
    keyPrefix: 'AdditionalTreatmentsList.EndPage',
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isRefill = searchParams.get('action') === 'refill';

  const steps = [1, 2, 3] as const;

  const getStepDescription = (n: (typeof steps)[number]) =>
    isRefill
      ? t(`Steps.Step${n}.DescriptionRefill`)
      : t(`Steps.Step${n}.Description`);

  return (
    <div className="flex w-full justify-center">
      <div className="max-w-[420px]">
        <div>
          <Tag
            size="small"
            intent="positive"
            leadingIcon={
              <Icon
                name="check_circle"
                size="small"
                color="text-content-positive"
              />
            }
          >
            {t('SuccessTag')}
          </Tag>
          <Text size="headingL" className="pt-xs">
            {t('Title')}
          </Text>
        </div>
        <div className="flex items-center w-full bg-grey-300 rounded-m overflow-hidden h-auto max-h-[180px] mt-l mb-l">
          <img
            className="w-full object-cover"
            src="/images/additional-treatments/atx-end-page-cover.jpg"
            alt=""
          />
        </div>
        <ul className="space-y-m">
          {steps.map((n) => (
            <li key={n} className="flex gap-s">
              <NumberedCircle value={n} />
              <div className="flex-1 space-y-xxs">
                <Text size="labelStrong" color="contentDefault">
                  {t(`Steps.Step${n}.Title`)}
                </Text>
                <Text size="bodyS" color="contentSubdued">
                  {getStepDescription(n)}
                </Text>
              </div>
            </li>
          ))}
        </ul>
        <div className="flex w-full justify-center mt-xl">
          <Button type="button" width="full" onClick={() => navigate('/')}>
            {t('GoToDashboard')} <Icon name="arrow_forward" size="medium" />
          </Button>
        </div>
      </div>
    </div>
  );
};
